import React from "react";
import Button from "react-bootstrap/Button";

const ActionStrategy = () => {
  return (
    <div className="action_strategy_sec">
      <div className="row">
        <div className="col-12">
          <div className="qep_grad ">
            <h2>Mission, Vision & Values</h2>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="goal_left">
            <div className="mb-3">
              <label className="form-label">Mission</label>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="Empower individuals with disabilities through quality, person-centered coordination."
              ></textarea>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="goal_left">
            <div className="mb-3">
              <label className="form-label">Vision</label>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="To create a community where all individuals have access to meaningful support and opportunities."
              ></textarea>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="goal_left">
            <div className="mb-3">
              <label className="form-label">Values</label>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="Dignity, Equity, Transparency, Compassion"
              ></textarea>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="qep_grad act_head">
            <h2>Action & Strategy</h2>
            <p>Strengths, Needs & Priorities</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <div className="qep_grad ">
              <h2>Organizational Strengths</h2>
            </div>
            <div className="table-responsive p-0">
              <table className="common_table table">
                <thead>
                  <tr>
                    <th>Strength Area</th>
                    <th>Supporting Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>Staff CIR retraining</span>
                    </td>
                    <td>
                      <span>98% compliance with required hours in Q2</span>
                      <p>Source: Training Portal</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Family/participant survey sent</span>
                    </td>
                    <td>
                      <span>
                        Maintained 91% average satisfaction across 2 surveys
                      </span>
                      <p>Source: Participant Survey</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Policy updates issued</span>
                    </td>
                    <td>
                      <span>100% of CIRs responded to within 24 hours</span>
                      <p>Source: CIR Log / SIMS</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Manual strength area"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Supporting data"
                  />
                </div>
              </div>
            </div>
            <div className="text-end">
              <Button variant="secondary" className=" ms-auto">
                Add Manual Strength
              </Button>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <div className="qep_grad ">
              <h2>Identified Needs</h2>
            </div>
            <div className="table-responsive p-0">
              <table className="common_table table">
                <thead>
                  <tr>
                    <th>Area of Concern</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>Staff CIR retraining</span>
                    </td>
                    <td>
                      <span>98% compliance with required hours in Q2</span>
                      <p>Source: Training Portal</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Family/participant survey sent</span>
                    </td>
                    <td>
                      <span>
                        Maintained 91% average satisfaction across 2 surveys
                      </span>
                      <p>Source: Participant Survey</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Policy updates issued</span>
                    </td>
                    <td>
                      <span>100% of CIRs responded to within 24 hours</span>
                      <p>Source: CIR Log / SIMS</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Area of concern"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Description"
                  />
                </div>
              </div>
            </div>
            <div className="text-end">
              <Button variant="secondary" className=" ms-auto">
                Add Manual Need
              </Button>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="meetinginvite_inner mb-3">
            <div className="qep_grad ps-0">
              <h2>Top Priorities for Next Quarter</h2>
            </div>
            <div className="table-responsive ">
              <table className="common_table table">
                <thead>
                  <tr>
                    <th>Priority</th>
                    <th>Rationale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>Staff CIR retraining</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Family/participant survey sent</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Policy updates issued</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-3 mb-0 tp_text">
              System suggests SMART-aligned actions based on data; editable by
              council.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionStrategy;
